var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "verify-popup-dialog",
      attrs: {
        visible: _vm.dialogVisible,
        title:
          _vm.kycStatus === 2
            ? _vm.$t("kyc.verifying_title")
            : _vm.$t("kyc.verify_popup_title"),
        width: "720px",
        "close-on-click-modal": false,
        "show-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onClose,
      },
    },
    [
      _vm.kycStatus === 2
        ? _c("div", { staticClass: "verify-body" }, [
            _c(
              "div",
              { staticClass: "verify-avatar" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "user",
                    "class-name": "verify-avatar-icon",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "verify-content" }, [
              _c("div", { staticClass: "verify-main" }, [
                _vm._v(_vm._s(_vm.$t("kyc.verifying_main"))),
              ]),
              _c("div", { staticClass: "verify-sub" }, [
                _vm._v(_vm._s(_vm.$t("kyc.verifying_sub"))),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "verify-body" }, [
            _c(
              "div",
              { staticClass: "verify-avatar" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "user",
                    "class-name": "verify-avatar-icon",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "verify-content" }, [
              _c("div", { staticClass: "verify-main" }, [
                _vm._v(_vm._s(_vm.$t("kyc.verify_main"))),
              ]),
              _c("div", { staticClass: "verify-sub" }, [
                _vm._v(_vm._s(_vm.$t("kyc.verify_sub"))),
              ]),
            ]),
          ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          staticStyle: { display: "flex", "justify-content": "flex-end" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.kycStatus !== 2
            ? _c(
                "el-button",
                {
                  staticClass: "verify-cancel",
                  on: { click: _vm.goToDashboard },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.cancel")))]
              )
            : _vm._e(),
          _vm.kycStatus !== 2
            ? _c(
                "el-button",
                {
                  staticClass: "verify-now",
                  attrs: { type: "primary" },
                  on: { click: _vm.onVerify },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.verify_now")))]
              )
            : _c(
                "el-button",
                {
                  staticClass: "verify-now",
                  attrs: { type: "primary" },
                  on: { click: _vm.goToDashboard },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.confirm")))]
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }